import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";
import { ACH_ICONS } from "@/lib/achievements";
import { Sparkles } from "lucide-react";

export default function Celebration({ event, onClose }) {
  useEffect(() => {
    if (!event) return;
    const shots = event.type === "level" ? 3 : 2;
    let i = 0;
    const fire = () => {
      confetti({ particleCount: 90, spread: 100, origin: { y: 0.4 }, colors: ["#E9E604", "#C9C600", "#F59E0B", "#FF5722", "#8B5CF6"] });
      i++;
      if (i < shots) setTimeout(fire, 350);
    };
    fire();
    const t = setTimeout(onClose, 4200);
    return () => clearTimeout(t);
  }, [event, onClose]);

  return (
    <AnimatePresence>
      {event && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-md p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="celebration-overlay"
        >
          <motion.div
            initial={{ scale: 0.6, y: 40, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 220, damping: 18 }}
            className="relative text-center max-w-sm w-full p-8 rounded-3xl border border-emerald-500/40 bg-[#12141C] shadow-2xl"
          >
            <motion.div
              className="w-24 h-24 mx-auto rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-400 flex items-center justify-center glow-emerald mb-5"
              animate={{ rotate: [0, -8, 8, -6, 0], scale: [1, 1.08, 1] }}
              transition={{ duration: 0.9, repeat: Infinity, repeatDelay: 0.6 }}
            >
              {event.type === "level" ? (
                <span className="font-display text-4xl font-black text-black">{event.level}</span>
              ) : (
                (() => { const Ic = ACH_ICONS[event.achievement?.icon] || Sparkles; return <Ic className="w-12 h-12 text-black" />; })()
              )}
            </motion.div>

            {event.type === "level" ? (
              <>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400 mb-1">Level Up</p>
                <h2 className="font-display text-3xl font-black mb-2">You reached Level {event.level}!</h2>
                <p className="text-white">Your consistency is paying off. Keep the momentum going.</p>
              </>
            ) : (
              <>
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-400 mb-1">Achievement Unlocked</p>
                <h2 className="font-display text-2xl font-black mb-2">{event.achievement?.name}</h2>
                <p className="text-white">{event.achievement?.desc}</p>
              </>
            )}

            <button onClick={onClose} data-testid="celebration-close" className="mt-6 h-11 px-6 rounded-xl bg-white text-black font-bold hover:opacity-90 transition-opacity">
              Let's go
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
